import { ROUTES } from '@/routes/paths';

export type PanelMode = 'routes' | 'barriers';

const STORAGE_KEY = 'rt.lastPanelMode';

/** URL path matching each panel mode — single source of truth. */
export const PANEL_MODE_PATH: Readonly<Record<PanelMode, string>> = {
  routes: ROUTES.ROUTES,
  barriers: ROUTES.BARRIERS,
};

/**
 * Resolves a URL pathname to a panel mode, or null for non-panel URLs
 * (Dashboard/Stats/404/etc).
 */
export function panelModeFromPath(pathname: string): PanelMode | null {
  if (pathname === ROUTES.ROUTES) return 'routes';
  if (pathname === ROUTES.BARRIERS) return 'barriers';
  return null;
}

/**
 * Last panel mode the user was on, persisted across reloads so the app
 * reopens where they left off. Falls back to `routes` — the more common
 * daily entry point (build a route).
 */
export function readLastPanelMode(): PanelMode {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === 'routes' || raw === 'barriers') return raw;
  } catch {
    // Private-browsing mode / quota: fall through to default.
  }
  return 'routes';
}

export function writeLastPanelMode(mode: PanelMode): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // Silent: preference just won't persist.
  }
}
